
export const PERMISSIONS = {
  READ: 'read',
  ADMIN: 'admin',
  USER_MANAGEMENT: 'user_management',
  TRIGGER_WORKFLOWS: 'trigger_workflows',
  AUDIT_LOGS: 'audit_logs',
  TRANSACTIONS_IN_LOG_ORACLE: 'transactions_in_log_oracle',
  JOBS_IN_LOG_ORACLE: 'jobs_in_log_oracle',
  R_KB_IN_LOG_ORACLE: 'r_kb_in_log_oracle',
  C_KB_IN_LOG_ORACLE: 'c_kb_in_log_oracle',
  U_KB_IN_LOG_ORACLE: 'u_kb_in_log_oracle',
  D_KB_IN_LOG_ORACLE: 'd_kb_in_log_oracle',
  AI_CHAT_IN_LOG_ORACLE: 'ai_chat_in_log_oracle',
  READ_ORGANIZATIONS: 'read_organizations',
  READ_S3_OBJECTS: 'read_s3_objects',
  CREATE_S3_OBJECTS: 'create_s3_objects',
  UPDATE_S3_OBJECTS: 'update_s3_objects',
  DELETE_S3_OBJECTS: 'delete_s3_objects',
} as const;

export type PermissionId = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
